import styled from 'styled-components';
import { Flex, RestrictedIndicator } from '@elementary/common-ui/components';
import { radius, space } from '@elementary/common-ui/style/utils';

const Card = styled(Flex)`
  align-items: center;
  padding: ${space('md', 'lg')};
  background: ${({ theme }) => theme.palette.surface.subtle};
  border: 1px dashed ${({ theme }) => theme.palette.border.default};
  border-radius: ${radius('sm')};
`;

const IncidentRestrictedMonitorCard = () => (
  <Card>
    <RestrictedIndicator />
  </Card>
);

export default IncidentRestrictedMonitorCard;
